import Route from '@ember/routing/route';
import { hash } from 'rsvp';
import { service } from '@ember/service';

export default class EmployeesHrisSettingsRoute extends Route {
  @service router;
  @service state;
  @service store;
  @service abilities;
  @service featureFlags;

  @service flashMessages;

  titleToken = 'HRIS sync';

  /**
   * `syncToggleError=1` arrives when the user is bounced back from app-store's
   * `/integrations/sync-toggle/[id]` route because the cross-store save failed.
   * Surface it once and strip the param so refreshes don't re-show the toast.
   */
  queryParams = {
    syncToggleError: { refreshModel: false },
  };

  beforeModel() {
    // Master feature-flag gate. Direct URL access is possible via app-store's
    // sync-toggle returnTo redirect, so a route-level guard belongs here in
    // addition to the tile visibility check on the parent integrations page.
    if (!this.featureFlags.isEnabled('hris-directory-sync')) {
      this.router.replaceWith('employees.integrations');
      return;
    }
    if (this.abilities.cannot('visit sync-settings')) {
      this.router.transitionTo('unauthorized');
    }
  }

  model() {
    const { currentCompany, currentLocation } = this.state;

    return hash({
      currentCompany,
      pluginInstalls: this.store.query('plugin-install', {
        filter: { location: currentLocation.id },
        include: 'plugin',
        page: { limit: 100 },
      }),
    });
  }

  setupController(controller, model) {
    super.setupController(controller, model);
    if (controller.syncToggleError) {
      this.flashMessages.showAndHideFlash('error', 'Could not update HRIS directory sync. Please try again.');
      controller.syncToggleError = null;
    }
  }
}
